import styled from 'styled-components';
import Select, { type SelectFieldProps as FormSelectFieldProps } from '../../../components/fields/SelectField';
import { type Brightness } from '../../context';
import { PorscheSelectCss } from './shared';
import withPorscheSelect from './withPorscheSelect';

const PorscheSelectField = styled(Select)<Brightness>`
    ${PorscheSelectCss}
`;

export type SelectFieldProps = FormSelectFieldProps & Brightness;

const SelectField = withPorscheSelect(PorscheSelectField);
export default SelectField;
